import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "light";
    const stored = localStorage.getItem("cx_theme");
    if (stored === "light" || stored === "dark") return stored;
    return "light";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    if (theme === "dark") document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
    localStorage.setItem("cx_theme", theme);
  }, [theme]);

  return [theme, setTheme];
}

export function useReveal() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Reset: on every route change, clear .in and re-observe
    document.querySelectorAll(".reveal.in").forEach((el) => el.classList.remove("in"));

    const setup = () => {
      const els = document.querySelectorAll(".reveal:not(.in)");
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("in");
              io.unobserve(e.target);
            }
          });
        },
        { rootMargin: "0px 0px -40px 0px", threshold: 0 }
      );
      els.forEach((el) => io.observe(el));
      return io;
    };
    let io = setup();
    // Re-run after initial render settles
    const t1 = setTimeout(() => {
      io.disconnect();
      io = setup();
    }, 120);
    const t2 = setTimeout(() => {
      io.disconnect();
      io = setup();
    }, 400);
    // Safety fallback: force reveal if any still hidden after 2s
    const t3 = setTimeout(() => {
      document.querySelectorAll(".reveal:not(.in)").forEach((el) => el.classList.add("in"));
    }, 2000);
    return () => {
      io.disconnect();
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [pathname]);
}
